var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-7f8e0da7"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "container" };
var _hoisted_2 = { class: "inline-flex items-center" };
var _hoisted_3 = { class: "text-lg text-medium" };
var _hoisted_4 = { class: "mt-5" };
var _hoisted_5 = { class: "grid grid-cols-12 gap-y-8 courses-grid sm:gap-x-8 md:gap-y-6" };
var _hoisted_6 = {
    key: 0,
    class: "container mt-7"
};
var _hoisted_7 = {
    key: 0,
    class: "text-lg text-medium"
};
var _hoisted_8 = {
    key: 1,
    class: "grid grid-cols-12 gap-y-4 mt-5 courses sm:gap-x-8 md:gap-y-6"
};
var _hoisted_9 = {
    key: 2,
    class: "mt-10 text-lg courses-empty"
};
import cardCourse from '@student/components/Elements/CardCourse.vue';
import { clone } from '@common/utils/Helpers/Helpers';
import { sortArrayByProperty } from '@common/utils/Array/Array';
import { CoreStore } from '@student/modules/store';
import Auth from '@common/modules/auth';
import Api from '@student/modules/api/api';
import { computed, onMounted, ref, watch } from 'vue';
import EInput from '@common/ui/EInput.vue';
import { useMeta } from '@common/hooks/useMeta';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SchoolCourses',
    setup: function (__props) {
        var t = useI18n().t;
        var searchQuery = ref('');
        var courses = ref([]);
        var loading = ref(false);
        var setTitle = useMeta().setTitle;
        var categories = computed(function () {
            var e_1, _a, e_2, _b, e_3, _c;
            var categoriesLocal = [];
            try {
                for (var _d = __values(courses.value), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var course = _e.value;
                    var _loop_1 = function (category) {
                        var existCategory = categoriesLocal.find(function (c) { return c.id === category.id; });
                        // Категории еще нет в новом массиве - добавляем
                        if (!existCategory) {
                            existCategory = clone(category);
                            categoriesLocal.push(existCategory);
                        }
                        // У категории нет списка курсов - добавляем
                        if (!existCategory.courses) {
                            existCategory.courses = [];
                        }
                        existCategory.courses.push(course);
                    };
                    try {
                        for (var _f = (e_2 = void 0, __values(course.categories)), _g = _f.next(); !_g.done; _g = _f.next()) {
                            var category = _g.value;
                            _loop_1(category);
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                }
                finally { if (e_1) throw e_1.error; }
            }
            // Сортируем категории
            // сортируем по имени, чтобы упорядочить при одинаковом order
            categoriesLocal = categoriesLocal.sort(function (a, b) {
                var aName = a.name.toLowerCase();
                var bName = b.name.toLowerCase();
                if (bName > aName) {
                    return aName > bName ? 1 : -1;
                }
                else {
                    return aName > bName ? 1 : 0;
                }
            });
            categoriesLocal = sortArrayByProperty(categoriesLocal, 'order', 'asc');
            var _loop_2 = function (category) {
                category.courses = sortArrayByProperty(category.courses, function (course) {
                    return course.categoryOrders[category.id];
                });
            };
            try {
                // Сортируем курсы внутри категорий
                for (var categoriesLocal_1 = __values(categoriesLocal), categoriesLocal_1_1 = categoriesLocal_1.next(); !categoriesLocal_1_1.done; categoriesLocal_1_1 = categoriesLocal_1.next()) {
                    var category = categoriesLocal_1_1.value;
                    _loop_2(category);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (categoriesLocal_1_1 && !categoriesLocal_1_1.done && (_c = categoriesLocal_1.return)) _c.call(categoriesLocal_1);
                }
                finally { if (e_3) throw e_3.error; }
            }
            if (searchQuery.value !== '') {
                var query_1 = searchQuery.value.toLowerCase().replace(/\s+/, '');
                categoriesLocal = categoriesLocal.filter(function (category) {
                    var categoryName = category.name.toLowerCase().replace(/\s+/, '');
                    // Если совпадение по названию категории - отображаем со всеми курсами
                    if (categoryName.includes(query_1)) {
                        return true;
                    }
                    // Если совпадение по названию курса в категории - отображаем только совпавшие курсы
                    category.courses = category.courses.filter(function (course) {
                        var courseName = course.name.toLowerCase().replace(/\s+/, '');
                        return courseName.includes(query_1);
                    });
                    if (category.courses.length > 0) {
                        return true;
                    }
                    // Если совпадений вообще нет - скрываем
                    return false;
                });
            }
            return categoriesLocal;
        });
        var coursesWithoutCategory = computed(function () {
            var query = searchQuery.value.toLowerCase().replace(/\s+/, '');
            var coursesLocal = courses.value.filter(function (course) {
                if (searchQuery.value !== '') {
                    var courseName = course.name.toLowerCase().replace(/\s+/, '');
                    // Если совпадение по названию курса - значит отображаем
                    if (!courseName.includes(query)) {
                        return false;
                    }
                }
                // Курс не принадлежит ни одной категории и не куплен пользователем
                return course.categories.length === 0;
            });
            // Сортируем курсы
            coursesLocal = sortArrayByProperty(coursesLocal, 'order', 'asc');
            return coursesLocal;
        });
        var myCourses = computed(function () {
            var query = searchQuery.value.toLowerCase().replace(/\s+/, '');
            var coursesLocal = courses.value.filter(function (course) {
                if (searchQuery.value !== '') {
                    var courseName = course.name.toLowerCase().replace(/\s+/, '');
                    // Если совпадение по названию категории - отображаем
                    var categoryMatch = course.categories.find(function (category) {
                        var categoryName = category.name.toLowerCase().replace(/\s+/, '');
                        return categoryName.includes(query);
                    });
                    // Если нет совпадений по навзанию или категориям - скрываем
                    if (!courseName.includes(query) && !categoryMatch) {
                        return false;
                    }
                }
                return course.allowed;
            });
            // Сортируем категории
            coursesLocal = sortArrayByProperty(coursesLocal, function (course) {
                return course.categories && course.categories.length > 0 ? (course.categories[0].order * 10) + course.categoryOrders[course.categories[0].id] : 100000 + course.order;
            }, 'asc');
            return coursesLocal;
        });
        var user = computed(function () { return Auth.getUser(); });
        var school = computed(function () { return CoreStore.school; });
        var getCourses = function () {
            loading.value = true;
            Api.getCourses().then(function (res) {
                var data = res.data;
                courses.value = data;
                loading.value = false;
            });
        };
        watch(user, function () {
            getCourses();
        });
        onMounted(function () {
            getCourses();
            setTitle(school.value.name);
        });
        return function (_ctx, _cache) {
            var _component_e_icon = _resolveComponent("e-icon");
            var _directive_loading = _resolveDirective("loading");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(EInput, {
                        modelValue: searchQuery.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((searchQuery).value = $event); }),
                        class: _normalizeClass([[
                                searchQuery.value === '' ? 'search-input--empty' : '',
                            ], "text-center search-input"]),
                        placeholder: _unref(t)('placeholders.searchCourses'),
                        theme: "gray",
                        clearable: ""
                    }, {
                        prepend: _withCtx(function () { return [
                            _createVNode(_component_e_icon, {
                                class: "text-gray-300 w-5 h-5",
                                icon: "search"
                            })
                        ]; }),
                        _: 1
                    }, 8, ["modelValue", "class", "placeholder"])
                ])), [
                    [_directive_loading, loading.value]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, function (category) {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                        (category.courses.length > 0)
                            ? (_openBlock(), _createElementBlock("section", {
                                key: category.id,
                                class: "container mt-7 category"
                            }, [
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("div", {
                                        style: _normalizeStyle({
                                            backgroundColor: category.color
                                        }),
                                        class: "shrink-0 mr-3 w-4 h-4 rounded-full"
                                    }, null, 4),
                                    _createElementVNode("h2", _hoisted_3, _toDisplayString(category.name), 1)
                                ]),
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("div", _hoisted_5, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.courses, function (course) {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: course.id,
                                                class: "col-span-12 course sm:col-span-6 lg:col-span-4 xl:col-span-3"
                                            }, [
                                                _createVNode(cardCourse, {
                                                    course: course,
                                                    class: "h-full"
                                                }, null, 8, ["course"])
                                            ]));
                                        }), 128))
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ], 64));
                }), 256)),
                (coursesWithoutCategory.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        (myCourses.value.length > 0 || categories.value.length > 0)
                            ? (_openBlock(), _createElementBlock("h2", _hoisted_7, _toDisplayString(_unref(t)('titles.withoutCategory')), 1))
                            : _createCommentVNode("", true),
                        (courses.value.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(coursesWithoutCategory.value, function (course) {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: course.id,
                                        class: "col-span-12 sm:col-span-6 lg:col-span-4 xl:col-span-3"
                                    }, [
                                        _createVNode(cardCourse, {
                                            course: course,
                                            class: "h-full"
                                        }, null, 8, ["course"])
                                    ]));
                                }), 128))
                            ]))
                            : _createCommentVNode("", true),
                        (courses.value.length === 0)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_unref(t)('messages.noCoursesAvailable')), 1))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
